import { AppColors } from "@/styles/colors";
import { Button, Flex } from "@chakra-ui/react";
import { Save, Undo } from "lucide-react";
import { RefObject, SetStateAction } from "react";

interface Props {
  loadingDays: boolean;
  hasChanges: boolean;
  saving: boolean;
  setCurrentBlockedDates: (value: SetStateAction<Set<string>>) => void;
  initialBlockedDatesRef: RefObject<Set<string>>;
  onSave: () => void;
}

export const LogisticAdditionalButtons = ({
  loadingDays,
  hasChanges,
  saving,
  setCurrentBlockedDates,
  initialBlockedDatesRef,
  onSave,
}: Props) => {
  return (
    <Flex gap={3}>
      <Button
        paddingX={4}
        disabled={loadingDays || saving || !hasChanges}
        onClick={() =>
          setCurrentBlockedDates(new Set(initialBlockedDatesRef.current))
        }
      >
        <Undo /> Deshacer
      </Button>
      <Button
        paddingX={4}
        bgColor={AppColors.GREEN_PRIMARY}
        disabled={loadingDays || saving || !hasChanges}
        onClick={onSave}
        loading={saving}
      >
        <Save /> Guardar cambios
      </Button>
    </Flex>
  );
};
